<template>
  <b-modal
    id="linkEspace"
    ref="linkEspaceModal"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    title="Liaison de forme et espace"
    :modal-class="'base-modal large-modal'"
    :lazy="true"
    @hide="handleClose"
  >
    <div class="row">
      <div class="col-4 px-0 zi-10">
        <data-filter-container
          :list="tableauxListing"
          :keys="['nom']"
          type="tableau"
          titre="Tous les tableaux"
          @selected="handleSelect"
        ></data-filter-container>
      </div>
      <div class="col-4 px-0 zi-5">
        <data-filter-container
          :list="espacesListing"
          :keys="['nom', 'code']"
          titre="Toutes les espaces"
          type="espace"
          @selected="handleSelect"
        ></data-filter-container>
      </div>
      <div class="col-4 px-0 zi-1">
        <data-filter-container
          :list="dataListing"
          :multiSelect="true"
          :linkedData="linkedData"
          titre="Sélectionner une/des données"
          type="espaceData"
          @multiSelect="handleMultiSelect"
        ></data-filter-container>
      </div>
    </div>
    <div slot="modal-footer" class="w-100">
      <div class="footer-action float-right">
        <b-button
          variant="outline-primary"
          size="md"
          class="mx-2"
          @click="handleClose"
        >
          Annuler
        </b-button>
        <b-button
          variant="primary"
          size="md"
          :disabled="!selection.length"
          @click="handleLinkEspace"
        >
          Lier
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import dataFilterContainer from '../dataFilterContainer'
export default {
  components: {
    dataFilterContainer
  },
  props: {
    tableauxListing: {
      type: Array,
      default: () => []
    },
    espacesListing: {
      type: Array,
      default: () => []
    },
    dataListing: {
      type: Array,
      default: () => []
    },
    linkedData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      selection: [],
      currentShapeId: null
    }
  },
  methods: {
    handleClose () {
      this.$emit('close')
      this.$refs['linkEspaceModal'].hide()
    },
    open (shapeId) {
      this.currentShapeId = shapeId
      this.$nextTick().then(() => {
        this.$refs['linkEspaceModal'].show()
      })
    },
    handleLinkEspace () {
      this.$emit('linkEspace', this.currentShapeId, this.selection)
      this.handleClose()
    },
    handleSelect (id, type) {
      this.$emit('selected', id, type)
    },
    handleMultiSelect (values) {
      this.selection = values
    }

  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/schemaFonctionnel/modal/linkEspaceModal.vue